import * as React from "react";
import { FormHelperText, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { changePassword, type ChangePassword } from "../../../lib/apis/v1/auth.service";
import FailSnackbar from "../../ui/snackbar/fail.component";
import SuccessSnackbar from "../../ui/snackbar/success.component";
import ConfirmModal from "../confirm.modal";
import type { ModalComponentProps } from "../../../types/modal.types";

export default function PasswordResetModal(props: ModalComponentProps) {
  const { id, onClose } = props;

  const [change, setChange] = React.useState({
    originalPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [helpText, setHelpText] = React.useState("");
  const [confirmHelpText, setConfirmHelpText] = React.useState(false);

  const passwordMutation = useMutation({
    mutationFn: (form: ChangePassword) => changePassword(form),
    onSuccess: (data) => {
      const { code, error } = data || {};
      if (code == 20001) {
        FailSnackbar("비밀번호 변경 실패 (현재 비밀번호와 일치하지 않습니다.)");
        setHelpText("현재 비밀번호가 맞지 않습니다.")
        return;
      }
      if (error) {
        FailSnackbar("비밀번호 변경 실패");
        return
      } else {
        SuccessSnackbar("비밀번호 변경 완료");
        onClose?.();
      }
    },
  });

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    setChange((prev) => ({ ...prev, [id]: value }));
  }

  return (
    <ConfirmModal
      id={id}
      onClose={onClose}
      title="비밀번호 변경"
      rightButton={{
        title: "비밀번호 변경",
        disabled: Object.values(change).some((value) => !value),
        onClick: () => {
          if (change.newPassword !== change.confirmPassword) {
            FailSnackbar("비밀번호 변경 실패 (비밀번호가 일치하지 않습니다.)");
            setConfirmHelpText(true);
            return;
          }
          passwordMutation.mutate(change);
        },
      }}
    >
      <div className="flex flex-col gap-4 mt-4">
        <div>

          <TextField
            id="originalPassword"
            className="w-[552px] h-[56px]"
            type="password"
            label="현재 비밀번호 입력*"
            slotProps={{ inputLabel: { shrink: true } }}
            error={helpText.length > 0}
            onChange={changeHandler}
          />
          <FormHelperText
            className="pl-4"
            error={helpText.length > 0}
          >
            {helpText}
          </FormHelperText>
        </div>
        <TextField
          id="newPassword"
          type="password"
          className="w-[552px] h-[56px]"
          label="새 비밀번호 입력*"
          slotProps={{ inputLabel: { shrink: true } }}
          onChange={changeHandler}
        />
        <div>
          <TextField
            id="confirmPassword"
            type="password"
            className="w-[552px] h-[56px]"
            label="새 비밀번호 확인*"
            slotProps={{ inputLabel: { shrink: true } }}
            onChange={changeHandler}
            error={confirmHelpText}
          />
          <FormHelperText
            error={confirmHelpText}
          >
            위에 입력한 새 비밀번호를 한번 더 입력해주세요.
          </FormHelperText>
        </div>
      </div>
    </ConfirmModal>
  );
};
